import { useState } from 'react';
import { api } from '@/lib/api';
import { Sparkles, Loader2 } from 'lucide-react';
import MarkdownMessage from '@/components/MarkdownMessage';

export default function MatchExplain({ listingId }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState('');
  const [err, setErr] = useState('');

  const run = async () => {
    if (open && text) { setOpen(false); return; }
    setOpen(true);
    if (text) return;
    setLoading(true); setErr('');
    try {
      const { data } = await api.post('/ai/match-explain', { listing_id: listingId });
      setText(data.explanation || '');
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Errore AI, riprova.');
    } finally { setLoading(false); }
  };

  return (
    <div className="mt-3">
      <button
        onClick={run}
        data-testid={`match-explain-${listingId}`}
        className="inline-flex items-center gap-1.5 text-xs font-medium text-chartreuse hover:underline"
      >
        <Sparkles size={13} strokeWidth={1.8}/>
        {open && text ? 'Nascondi spiegazione AI' : 'Spiega con AI'}
      </button>
      {open && (
        <div className="mt-2 rounded-xl border border-border/60 bg-secondary/40 p-3 text-sm">
          {loading ? (
            <div className="flex items-center gap-2 text-muted-foreground">
              <Loader2 size={14} className="animate-spin"/> Analisi in corso…
            </div>
          ) : err ? (
            <div className="text-destructive text-xs">{err}</div>
          ) : (
            <MarkdownMessage content={text}/>
          )}
        </div>
      )}
    </div>
  );
}
